export default {
  title: {
    id: 'product_page_obsolete_software_modal_title',
    defaultMessage: 'Obsolete',
  },
  close: {
    id: 'product_page_obsolete_software_modal_close',
    defaultMessage: 'Close',
  },
}
